<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      logoImageName: "",
    };
  },

  async mounted() {
    const link =
      document.querySelector("#dynamic-favicon") ||
      document.querySelector("link[rel*='icon']");
    if (link) {
      this.logoImageName = await this.getLogoImageName();
      link.href = `/api/static/images/icons/${this.logoImageName}`;
    }
  },

  methods: {
    ...mapActions(["getLogoImageName"]),
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/** 自定义根样式单 */
body {
  margin: 0;
}

div.el-pagination {
  text-align: right;
}

div.actions {
  text-align: center;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 00px;

  button {
    margin-left: 10px;
  }
}

div.searchForm {
  margin-top: 20px;
}

.table-row {
  a,
  a:visited {
    text-decoration: none;
  }
}

.el-table thead th.el-table__cell {
  background: #f5f7fa;
}
/** 自定义根样式单 */
</style>
